import { useMemo } from 'react';

import { useUrlQueryParam } from '../../../hooks/useUrlQueryParam';
import { verifyInviteToken } from '../../../lib/tokens';

export const useVerifiedInviteTokenData = () => {
    const jwtToken = useUrlQueryParam('token');
    return useMemo(() => verifyInviteToken(jwtToken || ''), [jwtToken]);
};
